import axiosInstance from '../config/axios';
import { API_ENDPOINTS } from '../config/api';

const base = API_ENDPOINTS.studyTeam;

export async function getStudyTeamByProject(projectId) {
  const res = await axiosInstance.get(base, { params: { projectId } });
  return res.data;
}

export async function upsertStudyTeam(payload) {
  const res = await axiosInstance.post(base, payload);
  return res.data;
}

export async function reassignStudyTeamPerson(projectId, { role, oldPerson, newPerson }) {
  const res = await axiosInstance.post(`${base}/${projectId}/reassign`, { role, oldPerson, newPerson });
  return res.data;
}
